import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { IEX_STATE_CODES } from '@constants/configs/states';

const STATES_WITH_LOWERCASE_PARTNER_RELATIONSHIP = [ IEX_STATE_CODES.NM,  IEX_STATE_CODES.NV ];

const TaxHouseholdCompositionSummary = props => {
    const {
        family: {
            allHhmAttributes: {
                common,
                individual
            }
        },
        isState
    } = props;
    
    const intl = useIntl();

    const getHhmsInfo = () => {
        return individual.map((individualAttributes, idx) => {
            const {
                partnerRelationshipTextId,
                status
            } = individualAttributes;

            const formattedPartnerRelationship = intl.formatMessage({ id: partnerRelationshipTextId });
            const partnerRelationship = STATES_WITH_LOWERCASE_PARTNER_RELATIONSHIP.some(state => isState[state])
                ? formattedPartnerRelationship.toLowerCase()
                : formattedPartnerRelationship;
            return (
                <p key = { idx } data-testid = { `tax_household_composition_summary_${idx}_${status}` } >
                    <FormattedMessage
                        id = { `ssap.family_household.tax_composition.brief_info_${status}` }
                        values = { {
                            ...common,
                            ...individualAttributes,
                            partnerRelationship
                        } }
                    />
                </p>
            );
        });
    };

    return (
        <div className = 'usa-alert gi-alert gi-alert__left-accent gi-alert__info' >
            <div className = 'gi-alert__body' >
                <p className = 'gi-alert__text' data-testid = 'tax_household_composition_summary_info_message' >
                    <FormattedMessage id = 'ssap.family_household.tax_composition.based_on_info' />
                </p>
                { getHhmsInfo() }
                <p key = 'disclaimer' data-testid = 'tax_household_composition_summary_disclaimer'>
                    <FormattedMessage id = 'ssap.family_household.tax_composition.disclaimer' />
                </p>
            </div>
        </div>
    );
};

export default TaxHouseholdCompositionSummary;